/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import { styled, Typography, Checkbox, Chip, Button } from "@mui/material";
import { SyncOutlined } from '@ant-design/icons'

export const StyledModalTitleContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginTop: '5px',
})

export const TitleContainer = styled('div')({
  display: 'flex',
  gap: '10px',
})

export const StyledModalTitle = styled(Typography)({
  fontSize: '20px',
  fontWeight: '600',
})

export const StyledDescription = styled(Typography)({
  fontSize: '16px',
  color: 'grey',
  marginTop: '5px',
})

export const StyledSyncIcon = styled(SyncOutlined)({
  color: '#EA580C',
  fontSize: '20px',
})

export const SourceTitle = styled(Typography)({
  fontSize: '12px',
  fontWeight: '600',
  color: 'gray',
  margin: '20px 0px 10px 0px',
})

export const SourceCard = styled('div', {
  shouldForwardProp: (prop) => prop !== 'selected',
})(({ selected }) => ({
  minHeight: '60px',
  border: selected ? '1px solid #EA580C' : '1px solid rgba(224, 224, 224, 1)',
  backgroundColor: selected ? '#faf3f1' : '#f7f7f7',
  borderRadius: '5px',
  padding: '5px',
  marginBottom: '15px',
}));

export const SourceCardContent = styled('div')({
  display: 'flex',
  gap: '10px',
  alignItems: 'baseline',
})

export const SourceType = styled('div')({
  display: 'flex',
  gap: '10px',
  alignItems: 'center',
})

export const SourceSymbol = styled('div')({
  height: '10px',
  width: '10px',
  borderRadius: '100%',
  backgroundColor: '#EA580C',
})

export const StyledSourceCheckBox = styled(Checkbox)({
  color: '#d4d3d3',
  '&.Mui-checked': {
    color: '#EA580C',
  },
})

export const StyledFetchButton = styled(Button)({
  textTransform: 'none',
  fontSize: '13px',
  backgroundColor: "#395bbd",
  '&:hover': {
    backgroundColor: "#395bbd",
  },
  borderRadius: '8px'
})

export const SourceData = ({
  badgeColor,
  sourceName,
  chipTitle,
  restaurantList,
  value,
  setFetchSource,
  fetchSource,
}) => {

  const handleSourceSelection = (event) => {
    const { checked, value } = event.target;
    setFetchSource(prev => ({...prev, [value]: checked}))
  }

  return (
    <SourceCard  selected={fetchSource?.[value] || false}>
      <SourceCardContent>
        <div>
          <StyledSourceCheckBox
            data-testid='source-checkbox'
            disableRipple
            value={value}
            onChange={handleSourceSelection}
          />
        </div>
        <div>
          <SourceType>
            <SourceSymbol sx={{ backgroundColor: badgeColor }} />
            <Typography 
              sx={{
                fontWeight: '600',
                fontSize: '14px'
              }}
            >
              {sourceName}
            </Typography>
            <Chip label={chipTitle} size="small" />
          </SourceType>
          <Typography 
            sx={{
              fontSize: '14px',
              marginTop: '5px'
            }}
          >
            {restaurantList}
          </Typography>
        </div>
      </SourceCardContent>
    </SourceCard>
  )
}
